import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

const styles = {
  dialog: {
    borderRadius: '12px',
    minWidth: '500px',
    maxWidth: '600px',
  },
  title: {
    backgroundColor: '#f44336',
    color: 'white',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  titleIcon: {
    fontSize: '28px',
  },
  content: {
    padding: '24px',
  },
  sectionTitle: {
    fontWeight: 600,
    color: '#d32f2f',
    marginTop: '16px',
    marginBottom: '8px',
    fontSize: '16px',
  },
  fieldList: {
    listStyle: 'none',
    padding: 0,
    margin: 0,
  },
  fieldItem: {
    padding: '8px 12px',
    marginBottom: '4px',
    backgroundColor: '#ffebee',
    borderLeft: '4px solid #f44336',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
  },
  fieldItemBullet: {
    marginRight: '8px',
    color: '#f44336',
    fontWeight: 'bold',
    fontSize: '18px',
  },
  validationItem: {
    padding: '8px 12px',
    marginBottom: '4px',
    backgroundColor: '#fff3e0',
    borderLeft: '4px solid #ff9800',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
  },
  validationItemIcon: {
    marginRight: '8px',
    color: '#ff9800',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  actions: {
    padding: '16px 24px',
    backgroundColor: '#fafafa',
  },
  closeButton: {
    backgroundColor: '#1976d2',
    color: 'white',
    padding: '8px 32px',
    fontWeight: 600,
  },
  divider: {
    margin: '16px 0',
  },
};

const ValidationModal = ({ open, onClose, missingFields = [], validationErrors = [] }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: styles.dialog }}
      aria-labelledby="validation-dialog-title"
    >
      <DialogTitle style={styles.title} id="validation-dialog-title">
        <ErrorOutlineIcon style={styles.titleIcon} />
        <span>Required Fields Missing</span>
      </DialogTitle>

      <DialogContent style={styles.content}>
        <Typography variant="body1" style={{ marginBottom: '16px' }}>
          Please complete the following before proceeding:
        </Typography>

        {missingFields.length > 0 && (
          <Box>
            <Typography style={styles.sectionTitle}>
              Missing Required Fields ({missingFields.length})
            </Typography>
            <ul style={styles.fieldList}>
              {missingFields.map((field, index) => (
                <li key={index} style={styles.fieldItem}>
                  <span style={styles.fieldItemBullet}>•</span>
                  {field}
                </li>
              ))}
            </ul>
          </Box>
        )}

        {validationErrors.length > 0 && (
          <Box>
            {missingFields.length > 0 && <Divider style={styles.divider} />}
            <Typography style={{ ...styles.sectionTitle, color: '#f57c00' }}>
              Validation Errors ({validationErrors.length})
            </Typography>
            <ul style={styles.fieldList}>
              {validationErrors.map((error, index) => (
                <li key={index} style={styles.validationItem}>
                  <span style={styles.validationItemIcon}>⚠</span>
                  {error}
                </li>
              ))}
            </ul>
          </Box>
        )}
      </DialogContent>

      <DialogActions style={styles.actions}>
        <Button onClick={onClose} style={styles.closeButton} variant="contained">
          Got It
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidationModal;
